<script setup>
import {useKitPages} from "@/composables/kit-settings/useKitPages";
import {computed, ref} from "vue";

defineProps({
  page: {
    type: Object,
    required: true,
  },
})

const {addPriorityPage} = useKitPages();
const {mutate: prioritisePage, isPending} = addPriorityPage();

const hovered = ref(false);
const starIcon = computed(() => hovered.value ? 'icons/gold-star-filled' : 'icons/gold-star');
</script>

<template>
  <div
    class="tw-w-full tw-flex tw-justify-between tw-items-center tw-p-8 tw-border tw-border-neutral-300 tw-rounded-xl"
    :class="{'tw-cursor-progress tw-pointer-events-none': isPending}"
  >
    <div class="tw-flex tw-gap-3 tw-min-w-0">
      <svg-vue
        v-tooltip="{
          content: 'Click to add this page to the priority list.',
          placement: 'bottom',
          theme: 'dark-blue-tooltip',
        }"
        class="tw-h-6 tw-min-w-6 tw-cursor-pointer"
        :icon="starIcon"
        @mouseenter="hovered = true"
        @mouseleave="hovered = false"
        @click.stop="prioritisePage(page.id)"
      />

      <div class="tw-text-base tw-font-bold tw-text-neutral-800 tw-truncate">
        {{ page.page_url }}
      </div>
    </div>
    <svg-vue
      v-if="isPending"
      class="tw-h-6 tw-min-w-6 tw-text-primary"
      icon="icons/loading"
    />
  </div>
</template>
